"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationBalance = void 0;
class AssignationBalance {
    user;
    simpleOrder;
    paidCash;
    paidOnline;
    sumOfPenalties;
    sumOfCompensations;
    sumOfSubsidies;
    sumOfPayouts;
    sumOfDebts;
    amountForDriver;
    driversBalance;
}
exports.AssignationBalance = AssignationBalance;
//# sourceMappingURL=AssignationBalance.js.map